import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgFire = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g style={{ mixBlendMode: 'overlay' }}>
      <path
        d='M5.15625 9.5999C5.69497 9.5999 6.21163 9.38919 6.59256 9.01412C6.97349 8.63904 7.1875 8.13034 7.1875 7.5999C7.1875 6.4959 6.78125 5.9999 6.375 5.1999C5.504 3.4855 6.193 1.9567 8 0.399902C8.40625 2.3999 9.625 4.3199 11.25 5.5999C12.875 6.8799 13.6875 8.3999 13.6875 9.9999C13.6875 10.7353 13.5404 11.4635 13.2546 12.1429C12.9687 12.8224 12.5498 13.4397 12.0217 13.9597C11.4935 14.4797 10.8666 14.8922 10.1765 15.1736C9.48647 15.4551 8.74689 15.5999 8 15.5999C7.25311 15.5999 6.51353 15.4551 5.82349 15.1736C5.13345 14.8922 4.50646 14.4797 3.97833 13.9597C3.4502 13.4397 3.03126 12.8224 2.74544 12.1429C2.45961 11.4635 2.3125 10.7353 2.3125 9.9999C2.3125 9.0775 2.66431 8.1647 3.125 7.5999C3.125 8.13034 3.33901 8.63904 3.71994 9.01412C4.10087 9.38919 4.61753 9.5999 5.15625 9.5999Z'
        fill='url(#paint0_radial_15307_17370)'
      />
    </g>
    <defs>
      <radialGradient
        id='paint0_radial_15307_17370'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(8 15.5) rotate(-90) scale(15 11.2253)'
      >
        <stop stopColor='white' stopOpacity='0.5' />
        <stop offset='1' stopColor='white' />
      </radialGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgFire)
export default ForwardRef
